module.exports = __webpack_public_path__ + "img/left-branch.f96cfefb.png";